import React, { useEffect } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import CertificateManagementTable from "../../../components/Admin/CertificateManagement/CertificateManagementTable/CertificateManagementTable";
import { certificateManagement } from "../../../utils/mainTabs/admin/certificateManagement/certificateManagement";

const CertificateManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tenantName, setAdminNavLinks, setAdminButtons, setAdminTiles } =
    useOutletContext();

  useEffect(() => {
    const { path, navLinks } = certificateManagement;
    const certificateManagementPath = path(tenantName);
    const certificateManagementNavLinks = navLinks(navigate, tenantName);
    if (location.pathname === certificateManagementPath) {
      setAdminTiles([]);
      setAdminNavLinks(certificateManagementNavLinks);
      setAdminButtons([]);
    }
  }, [
    tenantName,
    location.pathname,
    navigate,
    setAdminButtons,
    setAdminNavLinks,
    setAdminTiles,
  ]);

  return (
    <>
      <CertificateManagementTable />
    </>
  );
};

export default CertificateManagement;
